import { Router } from '@angular/router';
import { inject, Injectable, signal } from '@angular/core';
import { CmsApiService } from './api/cms-api.service';
import { of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { PlatformService } from './platform.service';
import { RedirectorService } from './redirector.service';
import { EnviromentType } from 'ngx-unificator/types/cms';
import { skipBotRules } from '../providers/bot-rules.provider';

export const EURO_COUNTRIES = ['ie', 'dk', 'it', 'is'];

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private _api = inject(CmsApiService);
  private _router = inject(Router);
  private _platform = inject(PlatformService);
  private _redirector = inject(RedirectorService);

  public loaded = signal<boolean>(false);
  public dataEnv = signal<Partial<EnviromentType>>({});

  public loadEnvironment() {
    return this._api.serviceEnvironment().pipe(
      switchMap(e => !e ? throwError({ error: { error: { stack: 'SyntaxError' } } }) : of(e)),
      catchError(error => {
        this._redirector.checkError(error);
        return of({
          data: {
            cacheControl: [],
            languageList: [],
            countryList: [],
            country: {
              short: '',
            },
            locale: {
              short: 'en-nz',
            },
          },
        });
      }),
      map((response: any) => {
        response.data.languageList.map((lang: any) => {
          lang.short = this._resolveLangShort(lang.short);
        });
        response.data.locale.short = this._resolveLangShort(response.data.locale.short);

        if (EURO_COUNTRIES.includes(response?.data?.country?.short)) {
          response.data.locale.short = 'en-eu';
        }

        this.dataEnv.set(response.data as EnviromentType);
        this.loaded.set(true);
        this._redirector.envData = this.dataEnv();
        this._checkRestrictCountry();

        return {
          ...response,
        };

      }),
    );
  }

  private _checkRestrictCountry() {
    if (this._platform.isBrowser && this.dataEnv()?.country?.isRestricted && !skipBotRules()) {
      setTimeout(() => {
        this._router.navigateByUrl('/403');
      }, 1000);
    }
  }


  /**
   * Check and change short locale
   * @param locale
   * @private
   */
  private _resolveLangShort(locale: string) {
    switch (locale) {
      case 'ce':
        return 'en-ca';
      case 'nz':
        return 'en-nz';
      case 'au':
        return 'en-au';
      default:
        return locale;
    }
  }

  /**
   * Returns true if user ip from provided countries
   *
   * @param countries
   */
  public isUserFrom(countries: string | string[]): boolean {
    if (!Array.isArray(countries)) {
      countries = [countries];
    }

    return this.dataEnv()
      && this.dataEnv().country
      && countries.includes(this.dataEnv().country.short);
  }
}
